import * as ActionTypes from './index';

export function setRelatedProducts(response) {
  return {
    type: ActionTypes.SET_RELATED_PRODUCTS,
    payload: response
  }
}

export function setRelatedProductsEdit(response) {
  return {
    type: ActionTypes.SET_RELATED_PRODUCTS_EDIT,
    payload: response
  }
}

export function clearRelatedProducts(response) {
  return {
    type: ActionTypes.CLEAR_RELATED_PRODUCTS,
    payload: response
  }
}



// WEBPACK FOOTER //
// ./src/actions/relatedProducts.js